import * as React from 'react';

/* Gjensidige Core 30 Imports */
import { Text, Title } from '@gjensidige/nci-core-typography';
import { Modal } from '@gjensidige/core-modal/lib/modal';

export interface Props {
  showModal: boolean;
  toggleModal: () => void;
}

const MarketingConsentModal: React.FC<Props> = ({ showModal, toggleModal }) => {
  return (
    <Modal
      ariaLabel="modal"
      ariaLabelCloseButton="Close modal"
      visible={showModal}
      closable
      onClick={toggleModal}
    >
      <div data-testid="content">
        <Title tag="h3">Elektronisk markedsføring</Title>
        <br />
        <Text>
          Når du takker ja til elektronisk markedsføring fra Gjensidige, vil du
          modtage meddelelser fra Gjensidige koncernen om rådgivning, nyheder og
          markedsføring af forsikringsprodukter og produkter og tjenester
          beslægtet med forsikring, der er tilpasset mig og mit kundeforhold,
          via. Du får også adgang til f.eks. særtilbud og eksklusive
          arrangementer, som udelukkende udbydes via e-mail og SMS. Du kan når
          som helst tilbagekalde dit samtykke på DinSide eller ved at kontakte
          Gjensidige Forsikring. Se hvordan i vores privatlivspolitik, som du
          finder på gjensidige.dk, hvor du også kan læse mere om vores
          behandling af personoplysninger.
        </Text>
      </div>
    </Modal>
  );
};

export default MarketingConsentModal;
